import { FixtureCompetitionTrckGrpLayout } from 'layouts/FixtureCompetitionTrckGrpLayout';

import type { LayoutParams } from './__generated__/routeParams';

export const TrckGrpLayout = () => {
  return <FixtureCompetitionTrckGrpLayout<LayoutParams> />;
};

export default TrckGrpLayout;
